import { getScrollPosition, setScrollPosition } from "components/StentorUIComponents";
import React, { PureComponent } from "react";
import { List, ListItemProps, ListTheme } from "react-toolbox/lib/list";
import { PageSelector } from "./PageSelector";
import style from "./style.scss";

const DEFAULT_ITEMS_PER_PAGE = 10;

export const listTheme: ListTheme = {
    list: style.list
};

export interface PagingListItemProps extends ListItemProps {
    caption?: string;
}

export interface PagingListProps<T> {
    readonly items: readonly T[];
    readonly activeItem?: T;
    readonly itemsPerPage: number;
    readonly page: number;
    pagination?: boolean;
    persistScrollPosition?: string;
    onRenderItem(item: T): JSX.Element;
    onPageChange(newPageNumber: number): void;
}

interface PagingListState {
    page: number;
}

export class PagingList<T> extends PureComponent<PagingListProps<T>, PagingListState> {
    static defaultProps: Partial<PagingListProps<any>> = {
        itemsPerPage: DEFAULT_ITEMS_PER_PAGE
    };

    private ref: React.RefObject<HTMLDivElement> = React.createRef();

    constructor(props: PagingListProps<T>) {
        super(props);

        this.state = {
            page: props.page || 1
        };

        this.handlePageSelected = this.handlePageSelected.bind(this);
    }

    componentDidMount() {
        if (this.props.persistScrollPosition && this.ref.current) {
            this.ref.current.scrollTop = getScrollPosition(this.props.persistScrollPosition);
        }
    }

    componentWillReceiveProps(newProps: PagingListProps<T>) {
        this.setState({
            page: newProps.page || 1
        });
    }

    componentWillUnmount() {
        if (this.props.persistScrollPosition) {
            setScrollPosition(this.props.persistScrollPosition, this.ref.current.scrollTop);
        }
    }

    handlePageSelected(pageNumber: number) {
        this.props.onPageChange(pageNumber);

        // reset the scrollPosition of the panel
        if (this.ref.current) {
            this.ref.current.scrollTop = 0;
        }
        setScrollPosition(this.props.persistScrollPosition, 0);
    }

    render() {
        const { itemsPerPage, onRenderItem, pagination } = this.props;
        const { page } = this.state;
        const length = Array.isArray(this.props.items) ? this.props.items.length : 0;
        const pageSize = itemsPerPage;
        const items = this.props.pagination ?
            this.props.items.slice((page - 1) * pageSize, page * pageSize) :
            this.props.items;

        return (
            <>
                <div className={style.panel} ref={this.ref}>
                    <List selectable ripple theme={listTheme}>
                        {items && items.map((item, i) => <React.Fragment key={i}>{onRenderItem(item)}</React.Fragment>)}
                    </List>
                </div>

                {pagination && (
                    <footer className={style.paging}>
                        <PageSelector
                            totalPages={Math.ceil(length / itemsPerPage)}
                            selectedPage={page}
                            onPageChange={this.handlePageSelected}
                        />
                    </footer>
                )}
            </>
        );
    }
}

export default PagingList;
